<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="allTripsObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for any trip </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="allTripsObj.isActive" v-model="allTripsObj.isActive"
                        @input="allTrips" :left-label="true">{{ allTripsObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <StandardRuleActions v-if="allTripsObj.isActive" :ruleObj="allTripsObj" :title="title" @save="updateActions" />
    </div>
</template>
<script>
import { all } from 'q';
import StandardRuleActions from "../StandardRuleActions.vue";

export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        StandardRuleActions
    },
    data() {
        return {
            allTripsObj: this.value ? this.value : {
                name: "allTrips",
                isActive: false,
                type: 'all',
                message: 'Trigger for any trip'
            },
            title: "All trips"
        }
    },
    methods: {
        allTrips() {

            if (!this.allTripsObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit('allTrips', this.allTripsObj)
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.allTripsObj.useCustomActions = false;
            delete this.allTripsObj.visibility;
            delete this.allTripsObj.approvalLevel;
            delete this.allTripsObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into allTripsObj
            this.allTripsObj = { ...this.allTripsObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams()
            }

            this.emitRuleObj();
        },
    },
    mounted() {
        this.allTripsObj.type = 'all';

        this.emitRuleObj();

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.allTripsObj = this.value;
                this.allTripsObj.type = 'all';
                this.emitRuleObj();

            },
            deep: true,
        },
    },
}
</script>